import React from 'react';
import { FaPlus } from 'react-icons/fa';

const AddressDropdown = ({ 
  userAddresses, 
  selectedAddress, 
  setSelectedAddress, 
  setShowAddressDropdown,
  setShowAddressForm 
}) => {
  return (
    <div className="mt-3">
      <div className="space-y-3 max-h-[130px] overflow-y-auto pr-1">
        {userAddresses.length > 0 ? (
          userAddresses.map((address) => (
            <div 
              key={address.createdAt}
              className={`p-3 border rounded-lg cursor-pointer ${selectedAddress?.createdAt === address.createdAt ? 'border-purple-500 bg-purple-50' : 'border-gray-200 hover:border-purple-300'}`}
              onClick={() => {
                setSelectedAddress(address);
                setShowAddressDropdown(false);
              }}
            >
              <div className="flex justify-between">
                <span className="font-medium">{address.name}</span>
                {address.isDefault && (
                  <span className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded-full">
                    Default
                  </span>
                )}
              </div>
              <p className="text-sm text-gray-600 mt-1">{address.addressLine1}, {address.addressLine2}</p>
                {address.addressLine2 && (
              <p className="text-sm text-gray-600"></p>
            )}
            <p className="text-sm text-gray-600">
              {address.city}, {address.state} - {address.pincode}
            </p>
              <p className="text-sm text-gray-600">Phone: {address.phone}</p>
            </div>
          ))
        ) : (
          <div className="text-center text-gray-500 py-2">
            No saved addresses
          </div>
        )}

        <button
          onClick={() => {
            setShowAddressForm(true);
            setShowAddressDropdown(false);
          }}
          className="w-full py-2 border border-dashed border-purple-400 text-purple-600 rounded-lg hover:bg-purple-50 flex items-center justify-center space-x-2"
        >
          <FaPlus size={14} />
          <span>Add New Address</span>
        </button>
      </div>
    </div>
  );
};

export default AddressDropdown;
